import { Tooltip } from "@xola/ui-kit";
import React from "react";
import { Resource } from "types";
import { useResource } from "../../../hooks/useResource";
import { NoTranslate } from "@/components/Common/NoTranslate";

interface InventoryNameProps {
    eventResource: { count: number; resource: { id: ID } };
    disableTooltip?: boolean;
}

export const InventoryName = ({ eventResource, disableTooltip = false }: InventoryNameProps) => {
    const { data: resource } = useResource<Resource>(["resources", eventResource.resource.id]);
    const resourceName = resource ? `${resource.name} (x${eventResource?.count})` : eventResource.resource.id;
    const line = `${resource?.name} (x${eventResource?.count})`; // Don't show resource ID, looks ugly on the dashboard

    return (
        <Tooltip disabled={disableTooltip} content={resourceName} placement="left">
            <NoTranslate data-resource-id={eventResource.resource.id} className="ui-inventory-name hover:underline">
                {line}
            </NoTranslate>
        </Tooltip>
    );
};
